import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { EmployeeEducation, EmployeeEducationCreate, EmployeeEducationFilter } from '../data/employeeEducation';

export function createEmployeeEducationService(client: AxiosInstance) {
  return createCrudService<EmployeeEducation, EmployeeEducationCreate, EmployeeEducationFilter>(
    client,
    '/hrm/EmployeeEducation',
    'id',
  );
}

export type EmployeeEducationService = CrudService<EmployeeEducation, EmployeeEducationCreate, EmployeeEducationFilter>;
